import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

export default function Layout() {
    const token = localStorage.getItem('token');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth >= 992;
            setIsDesktop(desktop);
            if (desktop) setSidebarOpen(false);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!token) {
        return <Outlet />;
    }

    const mainPadding = isDesktop ? '16px' : window.innerWidth < 576 ? '8px' : '12px';

    return (
        <div className="d-flex flex-column min-vh-100">
            <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="d-flex flex-grow-1">
                <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
                <main
                    className={`app-main ${isDesktop ? 'app-main--with-sidebar' : ''}`}
                    style={{ padding: mainPadding }}
                >
                    <div className="app-content">
                        <Outlet />
                    </div>
                </main>
            </div>
            {isDesktop && <Footer />}
        </div>
    );
}
